module.exports = __webpack_public_path__ + "img/letsdoitv2.cf881cf0.png";